import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProductsCarousel"] */ "/vercel/path0/src/components/featured-products-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroAnimations"] */ "/vercel/path0/src/components/hero-animations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["S3Image"] */ "/vercel/path0/src/components/S3Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBar"] */ "/vercel/path0/src/components/search/search-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimelineSection"] */ "/vercel/path0/src/components/timeline-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustSection"] */ "/vercel/path0/src/components/trust-section.tsx");
